export default {

    dropdownsContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        backgroundColor: 'rgb(245, 245, 245)'
    },
    searchButton: {
        width: '120px',
        margin: '10px'
    },
    tableHeader: {
        display: 'flex',
        justifyContent:'center',
        textAlign: 'center',
        alignItems: 'center'
    }

}



// WEBPACK FOOTER //
// ./src/Components/Report/ReportStyles.jsx